import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '@mui/material';

export const styles = (theme: Theme) =>
  createStyles({
    btnText: {
      marginLeft: theme.spacing(1),
    },
    popperClose: {
      pointerEvents: 'none',
    },
    popperResponsive: {
      zIndex: 5,
      [theme.breakpoints.down('lg')]: {
        ...theme.mixins.popperResponsive,
      },
    },
    dropdown: {
      ...theme.mixins.dropdown,
    },
    dropdownItem: {
      ...theme.mixins.dropdownItem,
    },
  });

export const useStyles = makeStyles<Theme>((theme) => ({
  btnText: {
    marginLeft: theme.spacing(1),
  },
  popperClose: {
    pointerEvents: 'none',
  },
  popperResponsive: {
    zIndex: 5,
    [theme.breakpoints.down('lg')]: {
      ...theme.mixins.popperResponsive,
    },
  },
  dropdown: {
    ...theme.mixins.dropdown,
  },
  dropdownItem: {
    ...theme.mixins.dropdownItem,
  },
}));
